import { Injectable } from '@angular/core';
import { ServerService } from '../../../core/services/server.service';
import { ProtoService } from '../../../core/services/proto.service';
import { DataService } from '../../../core/services/data.service';
import { AuthService } from '../../../core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  private addNew = true;
  private businessesProtos: {[key: string]: any } = {};
  private businessId: string = '';
  private businessName: string = '';
  private billProto: any;
  private historyFlag: boolean = false;
  private billPaidFlag: boolean = false;
  private billsModified: boolean = false;
  private locationId: string = '';
  private locationName: string = '';
  private locationsProtos: {[key: string]: any } = {};
  private message = {};

  constructor(private serverSrv: ServerService,
              private protoSrv: ProtoService,
              private dataSrv: DataService,
              private authSrv: AuthService) { }

  getAddNew() {
    return this.addNew;
  }

  setAddNew(flag: boolean) {
    this.addNew = flag;
  }

  getBusinessId() {
    return this.businessId;
  }

  getCurrentBusiness() {
    return this.businessesProtos[this.businessId];
  }

  addBusinessProto(proto: any, id: string) {
    this.businessesProtos[id] = this.protoSrv.getBusinessProtoCreateBusiness(proto);
  }

  getBillProto() {
    return this.billProto;
  }

  setBillProto(proto: any) {
    this.billProto = proto;
  }

  getHistoryFlag() {
    return this.historyFlag;
  }

  setHistoryFlag(flag: boolean) {
    this.historyFlag = flag;
  }

  getBillPaidFlag() {
    return this.billPaidFlag;
  }

  setBillPaidFlag(flag: boolean) {
    this.billPaidFlag = flag;
  }

  getBusinessName() {
    return this.dataSrv.getBusinessName();
  }

  // ============================== DATA ====================================

  setBusinessId(businessId: string) {
    this.businessId = businessId;
    return this.dataSrv.setBusinessId(businessId);
  }
  // ============================== AUTH ====================================

  setImpersonationUserId(userId: string) {
    this.authSrv.setImpersonationUserId(userId);
  }

  getImpersonationUserId() {
    return this.authSrv.getImpersonationUserId();
  }

  setImpersonationUserEmail(email: string) {
    this.authSrv.setImpersonationUserEmail(email);
  }

  getImpersonationUserEmail() {
    return this.authSrv.getImpersonationUserEmail();
  }

  isImpersonating() {
    return this.authSrv.isImpersonating();
  }

  // ============================== BUSINESSES ====================================

  getBusinesses() {
    const protobytes = this.protoSrv.createFindBusinessByUserActionProtoRequest(this.authSrv.getActiveUserId()); // create proto
    return this.serverSrv.postBin('findbusinesses', protobytes, this.authSrv.getAuthToken(), '');
  }

  createBusinesses(name: string, language: string, descriptionEn: string, descriptionEs: string) {
    const protobytes = this.protoSrv.createCreateBusinessActionProtoRequest(name,
                                                                            language,
                                                                            descriptionEn,
                                                                            descriptionEs,
                                                                            this.authSrv.getActiveUserId()); // create proto
    return this.serverSrv.postBin('createbusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  updateLogo(file: any, businessId: string) {
    const formData = new FormData();
    formData.append('logo', file, file.name);
    return this.serverSrv.postFile('updatebusinesslogo', formData, this.authSrv.getAuthToken(), '/' + businessId);
  }

  getAllBusinesses(proto: any) {
    const businesses: any = [];
    const aux = this.protoSrv.getBusinessesFromFindBusinessByUserActionProtoResponse(proto);
    let business;
    aux.forEach( (element: any) => {
      business = this.protoSrv.getBusinessInfo(element);
      businesses.push(business);
      this.businessesProtos[business.id] = element;
    });
    //console.log(businesses);
    return businesses;
  }

  updateBusiness(businessId: string, name: string, language: string, descriptionEn: string, descriptionEs: string) {
    const protobytes = this.protoSrv.createUpdateBusinessActionProtoRequest(businessId, name,
      language, descriptionEn, descriptionEs); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  updateBusiness2(colors: any) {
    const protobytes = this.protoSrv.createUpdateBusinessActionProtoRequest2(this.businessId,
      this.dataSrv.getBusinessName(), colors); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  updateBusinessBillingInfo(businessId: string, name: string, officialName: string, officialId: string, street: string,
                            city: string, state: string, country: string, postalCode: string) {
    const protobytes = this.protoSrv.createUpdateBillingInfoActionProtoRequest(businessId, name, officialName, officialId,
                                                                               street, city, state, country, postalCode); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  setBusiness(businessId: string, businessName: string, businessLogo: string, active: boolean) {
    this.setBusinessId(businessId);
    this.dataSrv.setBusinessId(businessId);
    this.dataSrv.setBusinessName(businessName);
    this.dataSrv.setBusinessLogoUrl(businessLogo);
    this.dataSrv.setBusinessProto(this.businessesProtos[businessId]);
    this.dataSrv.setBusinessActive(active);
  }

  addImageToSubmenu(file: any, submenu: string) {
    const formData = new FormData();
    formData.append('image', file, file.name);
    return this.serverSrv.postFile('addsubmenuimage', formData, this.authSrv.getAuthToken(),
                                   '?business-id=' + this.businessId + '&submenu-name=' + submenu);
  }

  deleteBusiness(id: string) {
    const protobytes = this.protoSrv.createDeleteBusinessActionProtoRequest(id); // create proto
    return this.serverSrv.postBin('deletebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  removeSubmenu(submenu: string, image: string) {
    const protobytes = this.protoSrv.createRemoveSubmenuActionProtoRequest(true, this.businessId, submenu, image); // create proto
    return this.serverSrv.postBin('removesubmenu', protobytes, this.authSrv.getAuthToken(), '');
  }

  findBills(id: string, history: boolean) {
    let protobytes;
    let address;
    if (history){
      protobytes = this.protoSrv.createFindBusinessBillsActionProtoRequest(id); // create proto
      address = 'findbills';
    } else {
      protobytes = this.protoSrv.createFindPendingBusinessBillsActionProtoRequest(id); // create proto
      address = 'findpendingbills';
    }
    return this.serverSrv.postBin(address, protobytes, this.authSrv.getAuthToken(), '');
  }

  getDetailFromFindPendindBusinessBills() {
    return this.protoSrv.getDetailFromFindPendindBusinessBills(this.billProto);
  }

  createMarkBillAsPaidActionProtoRequest(bill: string, transaction: string, business: string, country: number) {
    const protobytes = this.protoSrv.createMarkBillAsPaidActionProtoRequest(bill, transaction, business, country); // create proto
    return this.serverSrv.postBin('markaspaid', protobytes, this.authSrv.getAuthToken(), '');
  }

  createSendEmailActionProtoRequest(to: string, subject: string, body: string) {
    const protobytes = this.protoSrv.createSendEmailActionProtoRequest('', '', to, subject, body); // create proto
    return this.serverSrv.postBin('sendemail', protobytes, this.authSrv.getAuthToken(), '');
  }

  getAuthenticatedUser() {
    const protobytes = this.protoSrv.getAuthenticatedUserActionProtoRequest(); // create proto
    return this.serverSrv.postBin('getauthenticateduser', protobytes, this.authSrv.getAuthToken(), '');
  }

  findUser(email: string) {
    const protobytes = this.protoSrv.createFindUserActionProtoRequest(email); // create proto
    return this.serverSrv.postBin('finduser', protobytes, this.authSrv.getAuthToken(), '');
  }

  createSortSubmenuActionRequest(submenu: string, images: any[]) {
    const protobytes = this.protoSrv.createSortSubmenuActionProtoRequest(true, this.businessId, submenu, images); // create proto
    return this.serverSrv.postBin('sortsubmenu', protobytes, this.authSrv.getAuthToken(), '');
  }

  // ============================== ENABLE FEATURES ====================================
  createFeaturesFromLocationProto(features: any)
  {
    return this.protoSrv.createFeaturesFromLocationProto(features);
  }

  updateFeatures(external: any)
  {
    let protobytes;
    let resp;
    if (this.dataSrv.getBusinessActive()){
      protobytes = this.protoSrv.createUpdateFeaturesRequest( this.businessId, '', external); // create proto
      resp = this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
    }else{
      protobytes = this.protoSrv.createUpdateFeaturesRequest ( this.businessId, this.locationId, external); // create proto
      resp = this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
    }
    return resp
  }

  setCurrentFeatures(proto: any) {
    if (this.dataSrv.getBusinessActive())
      this.businessesProtos[this.businessId] = this.protoSrv.setBusinessFeatures(this.businessesProtos[this.businessId], proto);
    else
      this.locationsProtos[this.locationId] = this.protoSrv.setLocationFeatures(this.locationsProtos[this.locationId], proto);
  }

  getEnabledFeatures() {
    let features = {};
    if (this.dataSrv.getBusinessActive())
      features = this.protoSrv.getEnabledFeaturesFromBusinessProto(this.businessesProtos[this.businessId]);
    else
      features = this.protoSrv.getEnabledFeaturesFromLocationProto(this.locationsProtos[this.locationId]);
    return features;
  }

  decodeUpdateActionProtoResponse(data: any) {
    if (this.dataSrv.getBusinessActive())
      return this.protoSrv.decodeUpdateBusinessActionProtoResponse(data);
    else
      return this.protoSrv.decodeUpdateLocationActionProtoResponse(data);
  }

  isUpdateSuccess(data: any){
    if (this.dataSrv.getBusinessActive())
      return this.protoSrv.isUpdateBusinessSuccess(data);
    else
      return this.protoSrv.isUpdateLocationSuccess(data);
  }

  // ============================== TAX INFORMATION ====================================
  setCurrentBusinessTaxInformation(proto: any) {
    this.businessesProtos[this.businessId] = this.protoSrv.setBusinessTaxesInformation(this.businessesProtos[this.businessId], proto);
  }

  updateTaxInformationBusiness(businessId: string, taxNameAlcohol: string, taxAlcoholPercentage: string, saleTaxes: any[]) {
    const protobytes = this.protoSrv.createUpdateTaxInformationRequestBusiness(businessId,
      taxNameAlcohol, taxAlcoholPercentage, saleTaxes); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  // ============================== GLOBAL ALERTS ====================================

  // For businesses
  updateAlertsBusiness(businessId: string, email: string, phone: string) {
    const protobytes = this.protoSrv.createGlobalAlertProtoRequest(businessId, email, phone); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  // For locations
  updateLocationAlerts(locationId: string, email: string, phone: string) {
    const protobytes = this.protoSrv.createLocationAlertProtoRequest(locationId, email, phone); // create proto
    return this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
  }

  // =============================== BUSINESS HOURS ====================================
  updateBusinessHoursForBusiness(businessId: string, businessHours: any) {
    const protobytes = this.protoSrv.createUpdateHoursBusinessRequestBusiness(businessId, businessHours); // create proto
    return this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
  }

  setCurrentBusinessHours(proto: any) {
    this.businessesProtos[this.businessId] = this.protoSrv.setBusinessHoursToBusiness(this.businessesProtos[this.businessId], proto);
  }

  // ============================== LOCATIONS ====================================

  setLocation(locationId: string, locationName: string) {
    this.setLocationId(locationId);
    this.setLocationName(locationName);
    this.dataSrv.setLocationId(locationId);
    this.dataSrv.setLocationName(locationName);
    this.dataSrv.setBusinessActive(false);
  }

  setLocationProtos(protos: any[]){
    this.locationsProtos = protos;
  }

  getLocationId() {
    return this.locationId;
  }

  setLocationId(location: string) {
    this.locationId = location;
  }

  getLocationName() {
    return this.locationName;
  }

  setLocationName(name: string) {
    this.locationName = name;
  }

  getLocation() {
    return this.locationsProtos[this.locationId];
  }

  getLocations() {
    const protobytes = this.protoSrv.createFindLocationsByUserAndBusinessActionProtoRequest(
      this.authSrv.getActiveUserId(), this.dataSrv.getBusinessId()); // create proto
    return this.serverSrv.postBin('findlocations', protobytes, this.authSrv.getAuthToken(), '');
  }

  deleteLocation(id: string) {
    const protobytes = this.protoSrv.createDeleteLocationActionProtoRequest(id); // create proto
    return this.serverSrv.postBin('deletelocation', protobytes, this.authSrv.getAuthToken(), '');
  }

  updateLocation(locationId: string, name: string, street: string, city: string, state: string, country: string,
    postalCode: string, language: string, paymentRequired: boolean, orderPreparationDuration: number, phoneNumber: string) {
    const protobytes = this.protoSrv.createUpdateLocationActionProtoRequest(this.dataSrv.getBusinessId(), locationId,
    name, street, city, state, country, postalCode, language, paymentRequired, orderPreparationDuration, phoneNumber); // create proto
    return this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
  }

  createLocation(name: string, street: string, city: string,
    state: string, country: string, postalCode: string, orderPreparationDuration: number, language: string, phoneNumber: string) {
    const protobytes = this.protoSrv.createCreateLocationActionProtoRequest(this.dataSrv.getBusinessId(), this.dataSrv.getBusinessName(),
    name, street, city, state, country, postalCode, orderPreparationDuration, language, phoneNumber); // create proto
    return this.serverSrv.postBin('createlocation', protobytes, this.authSrv.getAuthToken(), '');
  }

  createTables(locationId: string, prefix: string, lower: number, upper: number, type: string) {
    const protobytes =
      this.protoSrv.createCreatePointsOfServiceActionProtoRequest(locationId, prefix, lower, upper, type); // create proto
    return this.serverSrv.postBin('createpointsofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  addLocationProto(proto: any, id: string) {
    this.locationsProtos[id] = this.protoSrv.getLocationProtoCreateLocation(proto);
    // console.log(this.locationsProtos);
  }

  getCurrencyCodeFromLocation(proto: any) {
    return this.protoSrv.getCurrencyCodeFromLocationProto(proto);
  }

  updateBusinessHoursForLocation(locationId: string, businessHours: any) {
    const protobytes = this.protoSrv.createUpdateHoursBusinessRequestLocation(locationId, businessHours); // create proto
    return this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
  }

  setCurrentLocationBusinessHours(proto: any) {
    this.locationsProtos[this.locationId] = this.protoSrv.setBusinessHoursToLocation(this.locationsProtos[this.locationId], proto);
  }

  getCountryFromLocationProto(proto: any) {
    return this.protoSrv.getCountryFromLocationProto(proto);
  }


  // ========================= STRIPE ENROLLMENT ==============================

  getIsEnrolledFromStripeAccountProto(proto: any) {
    return this.protoSrv.getIsEnrolledFromStripeAccountProto(proto);
  }

  createLocationStripeActionProtoRequest(locationId: string) {
    const protobytes = this.protoSrv.createLocationStripeActionProtoRequest(locationId); // create proto
    return this.serverSrv.postBin('enrolllocationpayments', protobytes, this.authSrv.getAuthToken(), '');
  }

  decodeLocationStripeActionProtoResponse(buffer: ArrayBuffer) {
    return this.protoSrv.decodeLocationStripeActionProtoResponse(buffer);
  }

  getRedirectUrlToEnrollInPaymentsFromLocationProto(proto: any) {
    return this.protoSrv.getRedirectUrlToEnrollInPaymentsFromLocationProto(proto);
  }

// ======================== DELIVERY ENROLLMENT =============================

getLocationDeliveryConfigFromLocationProto(proto: any, currencyCode: string) {
  return this.protoSrv.getLocationDeliveryConfigFromLocationProto(proto, currencyCode);
}

creatEnrollLocationInDeliveryActionProtoRequest(locationId: string) {
  const protobytes = this.protoSrv.creatEnrollLocationInDeliveryActionProto(locationId); // create proto
  return this.serverSrv.postBin('enrolllocationdelivery', protobytes, this.authSrv.getAuthToken(), '');
}

decodeEnrollLocationInDeliveryActionProtoResponse(buffer: ArrayBuffer) {
  return this.protoSrv.decodeEnrollLocationInDeliveryActionProtoResponse(buffer);
}

createUpdateDeliveryInLocationActionProto(businessId: string, locationId: string, deliveryConfig: any) {
  const protobytes = this.protoSrv.createUpdateDeliveryInLocationActionProto(businessId, locationId, deliveryConfig); // create proto
  return this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
}

createDeliveryConfigProtoFromLocationProto(deliveryConfig: any) {
  return this.protoSrv.createDeliveryConfigProtoFromLocationProto(deliveryConfig);
}

setCurrentDeliveryConfig(deliveryConfigProto: any) {
  this.locationsProtos[this.locationId] = this.protoSrv.setLocationDeliveryConfig(this.locationsProtos[this.locationId], deliveryConfigProto);
}






// ============================== TABLES ====================================

  getPointsofService() {
    const protobytes = this.protoSrv.createFindPointsofServiceByLocationActionProtoRequest(this.dataSrv.getLocationId()); // create proto
    return this.serverSrv.postBin('findpointsofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  getPointsofServiceById(locationId: any) {
    const protobytes = this.protoSrv.createFindPointsofServiceByLocationActionProtoRequest(locationId); // create proto
    return this.serverSrv.postBin('findpointsofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  createTable(name: string, type: string) {
    const protobytes =
      this.protoSrv.createCreatePointOfServiceActionProtoRequest(this.dataSrv.getLocationId(), name, type); // create proto
    return this.serverSrv.postBin('createpointofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  /*editName(tableId: string, name: string) {
    const protobytes = this.protoSrv.createUpdatePointOfServiceActionProtoRequest(this.dataSrv.getLocationId(),
      tableId, name); // create proto
    return this.serverSrv.postBin('updatepointofservice', protobytes, this.authSrv.getAuthToken(), '');
  }*/

  editPointOfService(tableId: string, name: string, type: string, vanityUrl: string) {
    const protobytes = this.protoSrv.createUpdatePointOfServiceActionProtoRequest(this.dataSrv.getLocationId(), tableId, name, type, vanityUrl);
    return this.serverSrv.postBin('updatepointofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  deletePointOfService(tableId: string) {
    const protobytes = this.protoSrv.createDeletePointOfServiceActionProtoRequest(tableId); // create proto
    return this.serverSrv.postBin('deletepointofservice', protobytes, this.authSrv.getAuthToken(), '');
  }

  downloadQRCode(tableId: string, size: string, language: string, theme: string) {
    const query = '/pointofservice/' + size + '/' + language + '/' + theme + '/' + tableId;
    const protobytes = new Uint8Array();
    // window.open(url, '_blank');
    return this.serverSrv.postBin('downloadQRcodes', protobytes, this.authSrv.getAuthToken(), query);
  }

  downloadAllQRCodes(size: string, language: string, theme: string) {
    const query = '/location/' + size + '/' + language + '/' + theme + '/' + this.dataSrv.getLocationId();
    const protobytes = new Uint8Array();
    // window.open(url, '_blank');
    return this.serverSrv.postBin('downloadQRcodes', protobytes, this.authSrv.getAuthToken(), query);
  }

  downloadPDFFile(data: ArrayBuffer, name: string){
    const blob: Blob = new Blob([data], {type: 'application/pdf' });
    const fileName: string = this.fixFileName(name) + '.pdf';
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  fixFileName(name: string) {
    return name.replace(/\W/g, '');
  }

  // ============================== SALES SUMMARY REPORT ====================================
  getSalesSummaryReportProto(fromYear: number, fromMonth: number, fromDay: number,
                           toYear: number, toMonth: number, toDay: number) {
    const protobytes = this.protoSrv.createGetSalesSummaryReportActionProtoRequest(this.dataSrv.getLocationId(), fromYear, fromMonth, fromDay,
                                                                                    toYear, toMonth, toDay ); // create proto
    return this.serverSrv.postBin('salessummary', protobytes, this.authSrv.getAuthToken(), '');
  }

  getOrdersReportProto(fromYear: number, fromMonth: number, fromDay: number,
                      toYear: number, toMonth: number, toDay: number, reportType: string,
                      continuation_token: string) {
    let protobytes = this.protoSrv.createFindOrdersReportActionProtoRequest( this.locationId, fromYear, fromMonth, fromDay,
                                                                toYear, toMonth, toDay, reportType, continuation_token ); // create proto
    let serverAction = '';
    switch (reportType){
      case "Paid":
        serverAction = 'findPaidOrder';
        break;
      case "Refunded":
        serverAction = 'findRefundedOrders';
        break;
      case "Disputed":
        serverAction = 'findDisputedOrders';
        break;
      case "All":
        serverAction = 'findPaidRefundedOrDisputedOrders';
        break;
      default:
        serverAction = 'error';
        break;
    }
    return this.serverSrv.postBin(serverAction, protobytes, this.authSrv.getAuthToken(), '');
  }

  // ======================================== MISC ===========================================
  setMessage(message: any){
    this.message = message;
  }

  getMessage(){
    return this.message;
  }

  // ================================== EXTERNAL LINKS ========================================
  createExternalLinksProto(facebook: string, instagram: string, linkedIn: string, tiktok: string,
                           twitter: string, website: string, youtube: string) {
    return this.protoSrv.createExternalLinksProto(facebook, instagram, linkedIn, tiktok, twitter, website, youtube);
  }

  getExternalLinksFromProto() {
    if (this.dataSrv.getBusinessActive()) {
      return this.protoSrv.getExternalLinksFromProto(null, this.businessesProtos[this.businessId]);
    } else {
      return this.protoSrv.getExternalLinksFromProto(this.locationsProtos[this.locationId], null);
    }
  }

  createUpdateExternalLinksRequest(externalLinksProto: any, linksToRemove: string[]) {
    let protobytes;
    let resp;
    if (this.dataSrv.getBusinessActive()) {
      protobytes = this.protoSrv.createUpdateExternalLinksRequest(this.getBusinessId(), '', externalLinksProto, linksToRemove); // create proto
      resp = this.serverSrv.postBin('updatebusiness', protobytes, this.authSrv.getAuthToken(), '');
    } else {
      protobytes = this.protoSrv.createUpdateExternalLinksRequest(this.getBusinessId(), this.getLocationId(), externalLinksProto, linksToRemove); // create proto
      resp = this.serverSrv.postBin('updatelocation', protobytes, this.authSrv.getAuthToken(), '');
    }
    return resp;
  }

  setExternalLinks(proto: any) {
    if (this.dataSrv.getBusinessActive()) {
      this.businessesProtos[this.businessId] = this.protoSrv.setBusinessExternalLinks(this.businessesProtos[this.businessId], proto);
    } else {
      this.locationsProtos[this.locationId] =  this.protoSrv.setLocationExternalLinks(this.locationsProtos[this.locationId], proto);
    }
  }

  // ================================= LOCATION METRICS ======================================
  getLocationMetricsProto(periodType: 'Daily' | 'Monthly' | 'Yearly' = 'Daily') {
    const protobytes = this.protoSrv.createFindLocationMetricsActionProtoRequest(this.locationId, periodType);
    return this.serverSrv.postBin('findlocationmetrics', protobytes, this.authSrv.getAuthToken(), '');
  }

  decodeFindLocationMetricsActionProtoResponse(answer: any) {
    return this.protoSrv.decodeFindLocationMetricsActionProtoResponse(answer);
  }




}
